import { RecordBase } from '../../providers/request/record-base.model';
import { BloodType } from './blood-type.enum';
import { EducationType } from './education-type.enum';
import { Gender } from './gender.enum';
import { IDCardType } from './id-card-type.enum';
import { MarriedStatus } from './married-status.enum';
import { OrganizationProjectSection } from './organization-project-section.model';
import { OrganizationType } from './organization-type.enum';
import { PoliticalStatus } from './political-status.enum';
import { UserPost } from './user-post.model';

export class User extends RecordBase {
  [key: string]: any;
  selectedSectionId?: number;
  projectId?: number;
  sectionId?: number;
  organizationId?: number;
  organizationName?: string;
  organizationShortName?: string;
  organizationNamePinYinFirst?: string;
  organizationType?: OrganizationType;
  departmentId?: number;
  departmentName?: string;
  departmentFullName?: string;
  postId?: number;
  postName?: string;
  postPerformance?: boolean;
  postSortOrder?: number;
  userPosts?: Array<UserPost>;
  performance?: boolean;
  sealHolder?: boolean;
  mainPost?: boolean;
  name?: string;
  gender?: Gender;
  idCardType?: IDCardType = IDCardType.CHINESE_ID_CARD;
  idCardNo?: string;
  idCardFace?: string;
  idCardFaceList?: Array<string> = [];
  idCardEmblem?: string;
  idCardEmblemList?: Array<string> = [];
  idCardList?: Array<string> = [];
  idCardAddress?: string;
  idCardExpDate?: number;
  idCardExpDateDate?: Date;
  idCardIssueDate?: number;
  idCardIssueDateDate?: Date;
  idCardIssueOrg?: string;
  nativePlace?: string;
  liveAddress?: string;
  phone?: string;
  addPlatUser?: boolean;
  needSign?: boolean = false;
  password?: string;
  ethnic?: string;
  politicalStatus?: PoliticalStatus;
  birthday?: number;
  birthdayDate?: Date;
  age?: number;
  height?: number;
  weight?: number;
  bloodType?: BloodType;
  marriedStatus?: MarriedStatus;
  childrenCount?: number;
  selfOnly?: boolean;
  educationType?: EducationType;
  status?: boolean;
  entryDate?: number;
  // entryDateDate?: Date;
  leaveDate?: number;
  // leaveDateDate?: Date;
  leave?: boolean;
  leaveComment?: string;
  certFileId?: string;
  certFileIdList?: Array<string> = [];
  emergencyContact?: string;
  emergencyPhone?: string;
  sectionValues?: string;
  organizationValues?: string;
  postValues?: string;
  smsEnable?: boolean;
  smsEnableTime?: number;
  comment?: string;
  outCode?: string;
  projectSections?: Array<OrganizationProjectSection> = [];
  // 前端使用字段
  currentAddPlatUser?: boolean;
  currentNeedSign?: boolean;
  orgSectionDisplay?: string;
  checked?: boolean;
  orgTypeSpan?: number = 1;
  sectionSpan?: number = 1;
  orgSpan?: number = 1;
  depSpan?: number = 1;
  postSpan?: number = 1;
  userId?: number;
  phoneHide?: string;
  idCardNoHide?: string;
  emergencyPhoneHide?: string;
}
